module.exports = __webpack_public_path__ + "static/media/README.a50e840c.md";